module.exports = __webpack_public_path__ + "img/Fizz_Cercle.6de142aa.png";